import { APIHandler } from "../apiHandler";

// https://github.com/jupyter/notebook/blob/master/notebook/services/kernels/handlers.py
class KernelHandler extends APIHandler {
  async delete() {
    this.setStatus(204);
    this.finish(null);
  }

  async post() {
    await this.proxyRequest();
  }
}

// tslint:disable-next-line:max-classes-per-file
class KernelActionHandler extends APIHandler {
  async post() {
    await this.proxyRequest();
  }
}

// tslint:disable-next-line:max-classes-per-file
class EmptyHandler extends APIHandler {
  async get() {
    this.setHeader("Content-Type", "application/json");
    this.finish([]);
  }
}

export const defaultHandlers: [string, typeof APIHandler][] = [
  ["/api/terminals", EmptyHandler],
  ["/api/kernels", EmptyHandler],
  ["/api/kernels/:kernel_id", KernelHandler],
  ["/api/kernels/:kernel_id/:action", KernelActionHandler],
];
